// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store.js'
import constant from './common/constant.js'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import BaiduMap from 'vue-baidu-map-v3'
import './common/EZUIKit/js/jsmpeg1.min'
import pingyinMath from 'pinyin-match'

// import x2js from 'x2js'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/iconfont.css'
import '@/assets/styles/main.scss'
import '@/assets/styles/base.scss'
import '@/assets/css/font-awesome.min.css'
import '@/assets/zdfont/iconfont.css'
import Vue2OrgTree from 'vue2-org-tree';
Vue.use(Vue2OrgTree);
import GeminScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminScrollbar);
import $ from 'jquery'
Vue.use(BaiduMap, {
  ak: 'Fvtako1U7b2ZHIfHC8FErBu2wmidUGxo'
});
import Print from 'vue-print-nb'
Vue.use(Print);
import VueAMap from 'vue-amap'
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '9fafa396fab6d7527b22203b77befb18',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType',
    'AMap.PolyEditor', 'AMap.CircleEditor', "AMap.MouseTool", "AMap.RectangleEditor"
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import Moment from 'moment'

Vue.prototype.$moment = Moment;
Vue.prototype.$driver = new Driver();
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$const = constant
Vue.prototype.$checkPhone = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/
Vue.prototype.$checkPhoneNew = /^((1[0-9]{10})|([0-9]{3,4})?[0-9]{7,8})$/g
Vue.prototype.$checkName = /^([一-龥]{1,20}|[a-zA-Z\\.\\s]{1,20})$/
ElementUI.Dialog.props.closeOnClickModal.default = false; // 修改 el-dialog 默认点击遮照为不关闭
import deptedittree from './components/dept/deptedittree';
Vue.use(deptedittree);/*使用自定义的公共组件*/
Vue.component('deptedittree',deptedittree);/*初始化公共组件*/
Vue.use(ElementUI, { zIndex: 1000 });

//xml 2 js object
//创建x2js对象，挂到vue原型上
// Vue.prototype.$x2js = new x2js();
let _this = this
/**权限指令**/
Vue.directive('has', {
  inserted: (el, binding) => {
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el);
    }
  },
  update: (el, binding, vnode) => {
    // if(el.parentNode!=null && el.getAttribute("type")==='button'){
    //   if(localStorage.getItem('removeOperation')=="true" ){
    //       el.parentNode.style.display='none';
    //       $("button:contains(编辑)").hide()
    //       $("button:contains(删除)").hide()
    //       $("button:contains(上报)").hide()
    //       $("button:contains(安全措施)").hide()
    //       $("button:contains(打印)").hide()
    //   }
    //   if(localStorage.getItem('removeOperation')=="false" ){
    //     el.parentNode.style.display='block';
    //     $("button").show()
    //   }
    // }
  },
  componentUpdated: function(el, binding, vnode) {

  },
});

$(".number").click(function() {
  console.log(".................................................................................")
});
Vue.directive("input-limit", {
  bind(el, binding) {
    var wins_0 = /[^\d]/g //整数判断
    var wins_1 = /[^\d^\.]/g //小数判断
    var flag = true;
    var points = 0;
    var lengths = 0
    var remainder = 0
    var no_int = 0
    const target = el instanceof HTMLInputElement ? el : el.querySelector("input");
    target.addEventListener("compositionstart", e => {
      flag = false;
    });
    target.addEventListener("compositionend", e => {
      flag = true;
    });
    target.addEventListener("input", e => {
      setTimeout(function() {
        if (flag) {
          if (binding.value == 0) {
            if (wins_0.test(e.target.value)) {
              e.target.value = e.target.value.replace(wins_0, "");
              e.target.dispatchEvent(new Event("input")) //手动更新v-model值
            }
          }
          if (binding.value == 1) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true
            }
            if ((e.target.value.split('.')).length - 1 > 1) {
              points = true
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 1) {
                lengths = true
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false
            } else {
              no_int = true
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace(
                  '$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
                  ".") + 2)
              } else {
                e.target.value = e.target.value.replace(wins_0, "")
              }
              e.target.dispatchEvent(new Event("input"))
            }
          }


          if (binding.value == 2) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true
            }
            if ((e.target.value.split('.')).length - 1 > 1) {
              points = true
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 2) {
                lengths = true
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false
            } else {
              no_int = true
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace(
                  '$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
                  ".") + 3)
              } else {
                e.target.value = e.target.value.replace(wins_0, "")
              }
              e.target.dispatchEvent(new Event("input"))
            }
          }
        }
      }, 0)
    })
  }
});
/*
**@author:HJY
**@time:2021/12/15 19:19:58
**@description:新增全局指令
*/

//限制点击频率
Vue.directive('frequency',{
  bind(el,binding){
    el.addEventListener('click',(e)=>{
      el.setAttribute('disabled','disabled');
      setTimeout(() => {
        el.removeAttribute('disabled');
      }, binding.value || 300);
    });
  }
});

//替换特殊字符
Vue.directive('delsp',{
  bind(el,binding){
    el.addEventListener('input',(e)=>{
      let reg = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、\s]/g,
          returnStr = e.target.value.replace(reg,'');
      e.target.value = returnStr;
      e.target.dispatchEvent(new Event("input"));
    });
  }
});

//权限检查方法
Vue.prototype.$_has = function(value) {
  let isExist = false;
  let buttonpermsStr = localStorage.getItem("perms");
  if (buttonpermsStr == undefined || buttonpermsStr == null) {
    return false;
  }
  let buttonperms = JSON.parse(buttonpermsStr);
  for (let i = 0; i < buttonperms.length; i++) {
    if (buttonperms[i].authority.indexOf(value) > -1) {
      isExist = true;
      break;
    }
  }
  return isExist;
};

Vue.prototype.isNormalUser = function() {
  let isNormalUser = false;
  let userinfoStr = localStorage.getItem("userinfo");
  let userinfo = JSON.parse(userinfoStr);
  return userinfo.isNormalUser;
}

//日期格式化过滤器
Vue.filter('format', function(val, arg) {
  if (!val) return;
  let pattern = 'yyyy-MM-dd HH:mm:ss';
  if (arg) {
    pattern = arg;
  }
  // let dt = new Date(val)
  // return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate() + ' '
  val = val.replace(/-/g, "/").substring(0, 19);
  return new Date(val).format(pattern);
})
//给日期对象加个format原型函数,用户处理日期格式化
//用法 var nowStr = new Date().format("yyyy-MM-dd HH:mm:ss");
Date.prototype.format = function(format) {
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(), //day
    "H+": this.getHours(), //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
    "S": this.getMilliseconds() //millisecond
  }
  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
}
//作业票使用：
// 在Vue的全局范围内添加一个时间格式化方法,全局使用：$formatTimeStr(参数)
// xx年xx月xx日 xx时xx分
Vue.prototype.$formatTimeStr = function(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${year}年${month}月${day}日 ${hours}时${minutes}分`;
};

//作业票使用(去掉秒)：格式为 年-月-日 时:分
Vue.prototype.$formatTimePt = function(str) {
  if (typeof str !== 'string') {
    return ''; // 如果不是字符串，返回空字符串
  }
  return str.length > 16 ? str.substring(0, 16) : str;
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js